import moment from 'moment';

export const getLatestArrivalTimeForInfant = ({ guardianID = '', booking = {} }) => {
  const getNonCancelledTrainForGuardian = [...(booking.outbound || []), ...(booking.inbound || [])].filter(
    (i) => !i.cancelled && i.products?.some((o) => !o.cancelled && o.passenger?.id === guardianID)
  );

  const trainsArrivalTime = getNonCancelledTrainForGuardian
    ?.filter(({ timing }) => {
      const validDate = timing?.arrivalDate === undefined ? '' : timing?.arrivalDate;
      return moment(validDate).isValid();
    })
    ?.map(({ timing }) => moment(timing?.arrivalDate));

  return trainsArrivalTime?.length > 0 ? moment.max(trainsArrivalTime) : null;
};
